/** Выбор произвольного периода.
 *
 *  Общий для разбора и выгрузки: «с 12 по 27» нужно и чтобы посмотреть поездку,
 *  и чтобы вынуть её в файл, а две копии одного календаря рано или поздно
 *  разошлись бы в трактовке границ.
 */
import { useState } from "react";
import type { Span } from "../lib/api.ts";
import { Sheet } from "./Sheet.tsx";

export function SpanSheet({ current, onClose, onPick, onClear }: {
  current: Span | null;
  onClose: () => void;
  onPick: (span: Span) => void;
  onClear: () => void;
}) {
  const today = new Date().toISOString().slice(0, 10);
  const [from, setFrom] = useState(current?.from ?? today);
  const [to, setTo] = useState(current?.to ?? today);

  return (
    <Sheet title="Свой период" onClose={onClose}>
      <p style={{ fontSize: "var(--f-caption)", color: "var(--text-muted)", lineHeight: 1.55,
                  marginTop: 0, marginBottom: "var(--s-4)" }}>
        Обе даты включительно. В чате такого выбора нет — там только текущий день,
        неделя и месяц.
      </p>
      <label style={{ display: "block", marginBottom: "var(--s-3)" }}>
        <span style={{ display: "block", fontSize: "var(--f-caption)",
                       color: "var(--text-muted)", marginBottom: "var(--s-2)" }}>С</span>
        <input type="date" value={from} onChange={(e) => setFrom(e.target.value)}
               style={dateInput} />
      </label>
      <label style={{ display: "block" }}>
        <span style={{ display: "block", fontSize: "var(--f-caption)",
                       color: "var(--text-muted)", marginBottom: "var(--s-2)" }}>По</span>
        <input type="date" value={to} onChange={(e) => setTo(e.target.value)}
               style={dateInput} />
      </label>
      <button type="button" onClick={() => onPick({ from, to })}
              style={{ width: "100%", minHeight: "var(--tap)", marginTop: "var(--s-5)",
                       padding: 14, borderRadius: "var(--r-field)", border: "none",
                       cursor: "pointer", font: "inherit", fontSize: "var(--f-body)",
                       fontWeight: 600, background: "var(--accent)", color: "var(--on-accent)" }}>
        Показать
      </button>
      {current && (
        <button type="button" onClick={onClear}
                style={{ width: "100%", minHeight: "var(--tap)", marginTop: "var(--s-2)",
                         padding: 14, borderRadius: "var(--r-field)", border: "none",
                         cursor: "pointer", font: "inherit", fontSize: "var(--f-body)",
                         fontWeight: 600, background: "var(--surface-2)", color: "var(--text)" }}>
          Вернуться к месяцу
        </button>
      )}
    </Sheet>
  );
}

const dateInput: React.CSSProperties = {
  width: "100%", minHeight: "var(--tap)", background: "var(--surface-2)", border: "none",
  borderRadius: "var(--r-field)", padding: "12px 14px", color: "var(--text)",
  font: "inherit", fontSize: "var(--f-body)",
};
